<template>
	<div class="index_editor clearfix" @mousedown="mousedown" @mouseup="mouseup" @mousemove="mousemove">
		<div class="header_body clearfix">
			<div class="header-title">
				<div class="header_title first">布局编辑</div>
				<div class="header_title">{{MapType}}</div>
				<div class="header_title time">{{MapName}}</div>
				<div class="header_title">（最新）</div>
			</div>
			<div class="header-function clearfix">
				<el-tooltip content="切换至 2 D" placement="bottom" effect="light">
					<div class="header_function Revoke hover" :class="{active:mapType == 1}" @click="changeMapType(1)">
						<img style="height: 19px;" :src="twoD" />
						<p>2D</p>
					</div>
				</el-tooltip>
				<el-tooltip content="切换至 2.5 D" placement="bottom" effect="light">
					<div class="header_function Revoke hover" :class="{active:mapType == 2}" @click="changeMapType(2)">
						<img style="height: 19px;" :src="twofiveD" />
						<p>2.5D</p>
					</div>
				</el-tooltip>

				<el-tooltip :content="sync?'Ctrl 已按住':'Ctrl 未按住'" placement="bottom" effect="light">
					<div class="header_function ctrl" :class="{'active': sync}">
						<p style="text-indent: 2px;">Ctrl</p>
					</div>
				</el-tooltip>
				<el-tooltip content="视角复原" placement="bottom" effect="light">
					<div class="header_function Revoke hover" @click="viewInitClick">
						<img :src="viewInit" />
						<p style="text-indent: 2px;">视角复原</p>
					</div>
				</el-tooltip>

				<el-tooltip content="撤销" placement="bottom" effect="light" :disabled="!Revoke">
					<div class="header_function Revoke" :class="{hover:Revoke}" @click="revoke">
						<img :src="Revoke?RevokeTrue:RevokeFalse" />
						<p style="text-indent: 2px;">撤销</p>
					</div>
				</el-tooltip>
				<!--<el-tooltip content="图层" placement="bottom" effect="light" :disabled="!Layer">-->
				<div class="header_function Layer" :class="{hover:Layer,active:headerCurrent==1}" header-id="Layer" ref="Layer" @click="headerClick('Layer')" title="图层">
					<img :src="Layer?LayerTrue:LayerFalse" :class="{active:headerCurrent==1}" header-id="Layer" />
					<p style="text-indent: -6px;" :class="{active:headerCurrent==1}" header-id="Layer">图层</p>
				</div>
				<!--</el-tooltip>-->
				<div class="Layer_list header_list clearfix" header-id="Layer" v-bind:class="{active:headerCurrent==1}">
					<div class="Layer_list_box_ab clearfix" header-id="Layer">
						<div class="Layer_list_box" @click="Layerclick(item.ClassName)" :class="item.ClassName" v-for="(item,index) in Layer_list" header-id="Layer">
							<span class="name" header-id="Layer">{{item.name}}</span>
							<span class="nameQuick" header-id="Layer">{{item.nameQuick}}</span>
						</div>
					</div>
				</div>

				<!--<el-tooltip content="对齐" placement="bottom" effect="light" :disabled="!Align">-->
				<div class="header_function Align" :class="{hover:Align,active:headerCurrent==2}" header-id="Align" ref="Align" @click="headerClick('Align')" title="对齐">
					<img :src="Align?AlignTrue:AlignFalse" :class="{active:headerCurrent==2}" header-id="Align" />
					<p style="text-indent: -7px;" :class="{active:headerCurrent==2}" header-id="Align">对齐</p>
				</div>
				<!--</el-tooltip>-->
				<div class="Align_list header_list" header-id="Align" :class="{active:headerCurrent==2}" :style="{'height': headerCurrent==2?mapType==2?'288px':'216px':0}">
					<div class="Align_list_box_ab clearfix" header-id="Align">
						<div class="Align_list_box" @click="Alignclick(item.id)" :class="item.ClassName" v-for="(item,index) in Align_list" v-if="item.type.indexOf(mapType) != -1" header-id="Align">
							<span class="name" header-id="Align">{{item.name}}</span>
							<span class="nameQuick" header-id="Align">{{item.nameQuick}}</span>
						</div>
					</div>
				</div>

				<!--<el-tooltip content="对齐" placement="bottom" effect="light" :disabled="!Mean">-->
				<div class="header_function Mean" :class="{hover:Mean,active:headerCurrent==3}" header-id="Mean" ref="Mean" @click="headerClick('Mean')" title="等距分布" style="margin-right: 10px;">
					<img :src="Mean?MeanTrue:MeanFalse" style="width: 28px;height: 18px;" :class="{active:headerCurrent==3}" header-id="Mean" />
					<p :class="{active:headerCurrent==3}" header-id="Mean">等距分布</p>
				</div>
				<!--</el-tooltip>-->
				<div class="Mean_list header_list" header-id="Mean" :class="{active:headerCurrent==3}" :style="{'height': headerCurrent==3?mapType==2?'144px':'73px':0}">
					<div class="Mean_list_box_ab clearfix" header-id="Mean">
						<div class="Mean_list_box" @click="Meanclick(item.id)" :class="item.ClassName" v-for="(item,index) in Mean_list" v-if="item.type.indexOf(mapType) != -1" header-id="Mean">
							<span class="name" header-id="Mean">{{item.name}}</span>
							<span class="nameQuick" header-id="Mean">{{item.nameQuick}}</span>
						</div>
					</div>
				</div>

				<div class="header_function_input" title="缩放">
					<vue-slider v-model="ValueNum" :data="data" :marks="true" :hide-label="true" :tooltip="'none'"></vue-slider>
				</div>

				<el-tooltip content="复制" placement="bottom" effect="light" :disabled="!Copy" style="margin-left: 10px;">
					<div class="header_function Copy" :class="{hover:Copy}" @click="CopyDraggable">
						<img :src="Copy?CopyTrue:CopyFalse" />
						<p>复制</p>
					</div>
				</el-tooltip>

				<el-tooltip content="粘贴" placement="bottom" effect="light" :disabled="!paste">
					<div class="header_function paste" :class="{hover:paste}" @click="PasteForDraggableThis">
						<img :src="paste?PasteTrue:PasteFalse" />
						<p>粘贴</p>
					</div>
				</el-tooltip>
			</div>
			<div class="header-function header-last">

				<el-tooltip content="保存" placement="bottom" effect="light">
					<div class="header_function Copy" :class="{hover:Copy}" @click="SaveDraggable">
						<img :src="saveTrue" />
						<p>保存</p>
					</div>
				</el-tooltip>

				<el-tooltip content="预览" placement="bottom" effect="light">
					<div class="header_function Copy" :class="{hover:Copy}" @click="PreviewDraggable">
						<img :src="previewTrue" />
						<p>预览</p>
					</div>
				</el-tooltip>

				<el-tooltip content="应用" placement="bottom" effect="light">
					<div class="header_function Copy" :class="{hover:Copy}" @click="UseSaveDraggable">
						<img :src="usesaveTrue" />
						<p>应用</p>
					</div>
				</el-tooltip>
			</div>
		</div>
		<div class="leftNavigation clearfix">

			<el-tooltip content="控件列表" placement="right" effect="light">
				<div class="leftNavigation_box control" leftNavigation-id="control" ref="control" :class="{active:leftNavigationCurrent==0}" @click="leftNavigationClick('control')">
				</div>
			</el-tooltip>

			<el-tooltip content="版本列表" placement="right" effect="light">
				<div class="leftNavigation_box Edition" leftNavigation-id="Edition" ref="Edition" :class="{active:leftNavigationCurrent==1}" @click="leftNavigationClick('Edition')">
				</div>
			</el-tooltip>
			<div class="Edition_list leftNavigation_list clearfix" leftNavigation-id="Edition" v-bind:class="{active:leftNavigationCurrent==1}">
				<div class="Edition_list_box_ab" leftNavigation-id="Edition">
					<div class="Edition_list_box" v-for="(item,index) in Edition_list" leftNavigation-id="Edition" @click="EditionChoice(item.id)">
						{{item.name}}
					</div>
				</div>

			</div>

			<el-tooltip content="草稿列表" placement="right" effect="light">
				<div class="leftNavigation_box draft" leftNavigation-id="draft" ref="draft" :class="{active:leftNavigationCurrent==2}" @click="leftNavigationClick('draft')">
				</div>
			</el-tooltip>
			<div class="draft_list leftNavigation_list" leftNavigation-id="draft" v-bind:class="{active:leftNavigationCurrent==2}">
				<div class="draft_list_box_ab" leftNavigation-id="draft">
					<div class="draft_list_box" v-for="(item,index) in draft_list" leftNavigation-id="draft" @click="draftChoice(item.id)">
						{{item.name}}
					</div>
				</div>
			</div>

			<!--<el-tooltip content="保存   Ctrl+s" placement="right" effect="light">
				<div class="leftNavigation_box Preservation" @click="SaveDraggable">

				</div>
			</el-tooltip>

			<el-tooltip content="预览" placement="right" effect="light">
				<div class="leftNavigation_box preview" @click="PreviewDraggable">

				</div>
			</el-tooltip>

			<el-tooltip content="应用" placement="right" effect="light">
				<div class="leftNavigation_box application" @click="UseSaveDraggable">

				</div>
			</el-tooltip>-->

		</div>
		<Equipment ref="Equipment" class='Equipment floatLeft_editor' :mapType="mapType" @setMapType="setMapType"></Equipment>
		<CanvasInt ref="CanvasInt" @inputBlur="inputBlur" @save='SaveDraggable' @updata='updata' :companyId='companyId' @clickGrid="clickGrid" :mapType="mapType" class='CanvasInt floatLeft_editor'></CanvasInt>
		<Attribute ref="Attribute" :companyId='companyId' class='Attribute floatLeft_editor' :mapType="mapType" @updata='updataCanvas' :GridSettingShow="SettingGridShow"></Attribute>
	</div>
</template>

<script>
	import CanvasInt from '@/components/MapEditor/canvas/canvas.vue';
	import Equipment from '@/components/MapEditor/equipment/equipment.vue';
	import Attribute from '@/components/MapEditor/attribute/attribute.vue';

	import { mapState } from 'vuex';
	import { mapActions } from 'vuex';
	import { mapMutations } from 'vuex';
	export default {
		name: 'index',
		data() {
			return {
				//当前组态类型 1为2D, 2为2.5D 默认为2.5D
				mapType: 2,
        SettingGridShow:false,    //地板设置显示
				WaitCopyX: 1,
				WaitCopyArr: [],
				formdata: '',
				//拖拽参数
				NameId: null,
				ContentName: null,
				width: 0,
				height: 0,
				mouseMark: false,

				autoSaveInterval: null, //自动保存定时器

				//顶部功能是否可选
				Revoke: true,
				Layer: true,
				Align: true,
				Mean: true,
				Copy: true,
				paste: true,

				//当前点击左侧栏的目标索引
				leftNavigationCurrent: 0,

				//当前点击顶部栏的目标索引
				headerCurrent: 0,

				//等级
				ValueNum: 100,
				data: [25, 31.25, 50, 62.5, 100],
				//当前企业历史版本
				Edition_list: [],

				//当前企业历史版本(草稿)
				draft_list: [],

				//当前图层
				Layer_list: [{
					id: 1,
					ClassName: 'top',
					name: '置顶',
					nameQuick: 'Shift+Ctrl+↑'
				}, {
					id: 2,
					ClassName: 'bottom',
					name: '置底',
					nameQuick: 'Shift+Ctrl+↓'
				}, {
					id: 3,
					ClassName: 'MoveUp',
					name: '上移一层',
					nameQuick: 'Ctrl+Alt+↑'
				}, {
					id: 4,
					ClassName: 'MoveDown',
					name: '下移一层',
					nameQuick: 'Ctrl+Alt+↓'
				}],

				Align_list: [{
					id: 1,
					name: 'x轴 对齐',
					nameQuick: 'Ctrl+Alt+L',
					type: [2],
				}, {
					id: 2,
					name: 'y轴 对齐',
					nameQuick: '',
					type: [2],
				}, {
					id: 3,
					name: '水平顶端对齐',
					nameQuick: '',
					type: [1,2],
				}, {
					id: 4,
					name: '水平底端对齐',
					nameQuick: '',
					type: [1,2],
				}, {
					id: 5,
					name: '水平中心居中',
					nameQuick: '',
					type: [1,2],
				}, {
					id: 6,
					name: '垂直左对齐',
					nameQuick: '',
					type: [1,2],
				}, {
					id: 7,
					name: '垂直右对齐',
					nameQuick: '',
					type: [1,2],
				}, {
					id: 8,
					name: '垂直中心对齐',
					nameQuick: '',
					type: [1,2],
				}],

				Mean_list: [{
					id: 9,
					name: 'x轴 等距',
					nameQuick: '',
					type: [2],
				}, {
					id: 10,
					name: 'y轴 等距',
					nameQuick: '',
					type: [2],
				}, {
					id: 11,
					name: '水平等距',
					nameQuick: '',
					type: [1,2],
				}, {
					id: 12,
					name: '垂直等距',
					nameQuick: '',
					type: [1,2],
				}],
			}
		},
		components: {
			CanvasInt,
			Equipment,
			Attribute
		},
		computed: {

			...mapState("defaultImgOptions", {
				draggable: 'draggable',
				defaultBasicConfig: 'defaultBasicConfig',
				defaultDeviceConfig: 'defaultDeviceConfig',
				index: 'index',
				currentIndex: 'currentIndex',
				revokeDraggable: 'revokeDraggable',
				editorLeft: 'editorLeft',
				editorTop: 'editorTop',
				MapType: 'MapType',
				MapName: 'MapName',
        MapBgData:"MapBgData",
				step: 'step',
				sync: 'sync'
			}),
			companyId() {
				return this.$store.state.companyId;
			},
			scaleLevel() { //缩放等级:0.3-1
				return this.$store.getters['defaultImgOptions/getScaleLevel'];
			},
			twoD() {
				return require('@/assets/image/editor/icon/2D.png');
			},
			twofiveD() {
				return require('@/assets/image/editor/icon/2.5D.png');
			},
			viewInit() {
				return require('@/assets/image/editor/icon/viewTrue.png');
			},
			RevokeTrue() {
				return require('@/assets/image/editor/icon/RevokeTrue.png');
			},
			RevokeFalse() {
				return require('@/assets/image/editor/icon/RevokeFalse.png');
			},

			LayerTrue() {
				return require('@/assets/image/editor/icon/LayerTrue.png');
			},
			LayerFalse() {
				return require('@/assets/image/editor/icon/LayerFalse.png');
			},

			AlignTrue() {
				return require('@/assets/image/editor/icon/AlignTrue.png');
			},
			AlignFalse() {
				return require('@/assets/image/editor/icon/AlignFalse.png');
			},

			MeanTrue() {
				return require('@/assets/image/editor/icon/MeanTrue.png');
			},
			MeanFalse() {
				return require('@/assets/image/editor/icon/MeanFalse.png');
			},

			CopyTrue() {
				return require('@/assets/image/editor/icon/CopyTrue.png');
			},
			CopyFalse() {
				return require('@/assets/image/editor/icon/CopyFalse.png');
			},

			PasteTrue() {
				return require('@/assets/image/editor/icon/PasteTrue.png');
			},
			PasteFalse() {
				return require('@/assets/image/editor/icon/PasteFalse.png');
			},

			saveTrue() {
				return require('@/assets/image/editor/icon/Preservation.png');
			},
			previewTrue() {
				return require('@/assets/image/editor/icon/preview.png');
			},
			usesaveTrue() {
				return require('@/assets/image/editor/icon/application.png');
			}
		},
		beforeCreate() {
			let count = 0;
			let imgs = [
				/*预加载*/
				require('@/assets/image/editor/Device/Compressor.png'),
				require('@/assets/image/editor/05.png'),
				require('@/assets/image/editor/025.png'),
				require('@/assets/image/editor/03125.png'),
				require('@/assets/image/editor/0625.png'),
				require('@/assets/image/editor/100.png'),
				require('@/assets/image/editor/gray_top_png.png'),
				require('@/assets/image/editor/gray_top_gif.gif'),
				require('@/assets/image/editor/gray_png.png'),
				require('@/assets/image/editor/gray_gif.gif'),
				require('@/assets/image/editor/red_top_png.png'),
				require('@/assets/image/editor/red_top_gif.gif'),
				require('@/assets/image/editor/red_png.png'),
				require('@/assets/image/editor/red_gif.gif'),
				require('@/assets/image/editor/blue_top_png.png'),
				require('@/assets/image/editor/blue_top_gif.gif'),
				require('@/assets/image/editor/blue_png.png'),
				require('@/assets/image/editor/blue_gif.gif'),
			]
			for(let img of imgs) {
				let image = new Image();
				image.src = img;
				image.onload = () => {
					count++;
				};
			}
		},
		created() {
			this.$parent.ChangeHeaderShow('hide');
			this.revokeStorageClear(); /*清空撤销状态存储数组*/
			this.recoverStorageClear(); /*清空恢复状态存储数组*/
			this.editorLeftClear(); /*清空编辑器偏移量*/
			this.editorTopClear(); /*清空编辑器偏移量*/
		},
		mounted() {
			var self = this;
			window.onbeforeunload = function() {
				if(self.step > 0) {
					return '当前编辑的版本尚未保存，是否确定离开?'
				}
			};
			document.oncontextmenu = function() {
				return false;
			};
			this.ValueNum = this.scaleLevel * 100;

			//获取历史版本
			this.getVersionList();
			//获取草稿历史版本
			this.getDraftVersionList();
			//十分钟自动保存一次草稿
			this.autoSaveInterval = setInterval(() => {
				if(self.step > 0) {
					self.SaveDraggableAuto(); //保存信息的操作
				}
			}, 600000)

		},
		methods: {
			...mapMutations("defaultImgOptions", {
				draggableBasicAdd: 'draggableBasicAdd',
				draggableDeviceAdd: 'draggableDeviceAdd',
				CurrentPosition: 'CurrentPosition',
				ShowActiveUpdata: 'ShowActiveUpdata',
				scaleLevelModify: 'scaleLevelModify',
				ActiveForDraggableAllFalse: 'ActiveForDraggableAllFalse',
				NowActiveModifyTrue: 'NowActiveModifyTrue',
				AutoAttachConnectPoint: 'AutoAttachConnectPoint',
				AutoAttachSkewAlignment: 'AutoAttachSkewAlignment',
				AutoAttachEquiSkewAlignment: 'AutoAttachEquiSkewAlignment',
				SkewAlignmentClose: 'SkewAlignmentClose',
				SkewAlignmentEquipmentClose: 'SkewAlignmentEquipmentClose',
				SkewAlignmentShow: 'SkewAlignmentShow',
				SkewAlignmentEquipmentShow: 'SkewAlignmentEquipmentShow',
				NearClose: 'NearClose',
				FarClose: 'FarClose',
				ObliqueAlignmentX: 'ObliqueAlignmentX',
				ObliqueAlignmentY: 'ObliqueAlignmentY',
				HorizontalAlignmentTop: 'HorizontalAlignmentTop',
				HorizontalAlignmentBottom: 'HorizontalAlignmentBottom',
				HorizontalAlignmentCenter: 'HorizontalAlignmentCenter',
				HorizontalAlignmentMean: 'HorizontalAlignmentMean',
				VerticalAlignmentLeft: 'VerticalAlignmentLeft',
				VerticalAlignmentRight: 'VerticalAlignmentRight',
				VerticalAlignmentCenter: 'VerticalAlignmentCenter',
				VerticalAlignmentMean: 'VerticalAlignmentMean',
				zIndexTop: 'zIndexTop',
				zIndexBottom: 'zIndexBottom',
				zIndexMoveUp: 'zIndexMoveUp',
				zIndexMoveDown: 'zIndexMoveDown',
				draggableUpdata: 'draggableUpdata',
				CopyDelForDraggable: 'CopyDelForDraggable',
				revokeStorage: 'revokeStorage',
				revokeStorageClear: 'revokeStorageClear',
				recoverStorageClear: 'recoverStorageClear',
				RevokeStorageBack: 'RevokeStorageBack',
				editorLeftClear: 'editorLeftClear',
				editorTopClear: 'editorTopClear',
				HiddenConnectPoint: 'HiddenConnectPoint',
				MapUpdata: 'MapUpdata',
				stepClear: 'stepClear',
				editorClearTipUpdate: 'editorClearTipUpdate'
			}),
			changeMapType(type) {
				//type => 1为2D, 2为2.5D
				this.mapType = type
			},
      // 接口获取的maptype
      setMapType(i){
        this.mapType = i
        this.$forceUpdate()
      },
			inputBlur() {
				this.$refs.Attribute.inputBlur();
			},
      // 点击地板
      clickGrid(status){
        console.log('clickGrid emit',status)
        this.SettingGridShow = status
      },

			viewInitClick() {
				this.editorLeftClear(); /*清空编辑器偏移量*/
				this.editorTopClear(); /*清空编辑器偏移量*/
				this.$refs.CanvasInt.editorClear();
			},
			revoke() {
				this.RevokeStorageBack();
				this.updata();
			},
      updataCanvas(){
				this.$refs.CanvasInt.updateStyle(this.currentIndex);
      },
			updata() {
				this.$refs.Attribute.settingConfigChange(this.currentIndex);
			},
			getVersionList() {
				/*获取历史版本列表*/
				this.get('/DeviceMap/getVersionList', {
					companyId: this.companyId
				}).then((res) => {
					if(res.success == true) {
						var array = res.result;　　
						/*for(var i = 0; i <= array.length / 2; i++) {　　　　
							var temp = array[i];　　　　
							array[i] = array[array.length - 1 - i];　　　　
							array[array.length - 1 - i] = temp;　　
						}*/
						this.Edition_list = array;
					}
				})
			},
			getDraftVersionList() {
				/*获取草稿版本列表*/
				this.get('/DeviceMap/getDraftVersionList', {
					companyId: this.companyId
				}).then((res) => {
					if(res.success == true) {
						var array = res.result;　　
						/*for(var i = 0; i <= array.length / 2; i++) {　　　　
							var temp = array[i];　　　　
							array[i] = array[array.length - 1 - i];　　　　
							array[array.length - 1 - i] = temp;　　
						}*/
						this.draft_list = array;
					}
				})
			},
			//保存
			SaveDraggable() {
				this.HiddenConnectPoint();
				this.stepClear();
				let objDraggable = JSON.parse(JSON.stringify(this.draggable.filter(item => item.ShowActive == true)))
				/*for(let obj of objDraggable){
					if(obj.ImgUrl){
						if(obj.ImgUrl.indexOf('http') != -1){
							obj.ImgUrl = new URL(obj.ImgUrl).pathname;
						}
					}
				}*/
				let content = {
					draggable: objDraggable,
					scaleLevel: this.scaleLevel,
          mapType:this.mapType,
          MapBgData:this.$store.state.MapBgData
				}
				content = JSON.stringify(content)
				let formdata = new FormData();
				formdata.append('name', this.common.getTime()); //下面是要传递的参数
				formdata.append('type', 2);
				formdata.append('companyId', this.companyId);
				formdata.append('content', content);

				this.postForm('/DeviceMap/create', formdata).then((res) => {
					if(res.success == true) {
						localStorage.setItem('updataMark', 'true');
						this.$message({
							showClose: true,
							message: '保存成功',
							type: 'success',
							customClass: 'backMessage',
							offset: 55,
						});
						this.getDraftVersionList();
					}
				})
			},
			//保存
			SaveDraggableAuto() {
				this.HiddenConnectPoint();
				this.stepClear();
				let objDraggable = JSON.parse(JSON.stringify(this.draggable.filter(item => item.ShowActive == true)))
				/*for(let obj of objDraggable){
					if(obj.ImgUrl){
						if(obj.ImgUrl.indexOf('http') != -1){
							obj.ImgUrl = new URL(obj.ImgUrl).pathname;
						}
					}
				}*/
				let content = {
					draggable: objDraggable,
					scaleLevel: this.scaleLevel,
          mapType:this.mapType,
          MapBgData:this.MapBgData
				}
				content = JSON.stringify(content)
				let formdata = new FormData();
				formdata.append('name', this.common.getTime() + '(自动保存)'); //下面是要传递的参数
				formdata.append('type', 2);
				formdata.append('companyId', this.companyId);
				formdata.append('content', content);

				this.postForm('/DeviceMap/create', formdata).then((res) => {
					if(res.success == true) {
						localStorage.setItem('updataMark', 'true');
						this.$message({
							showClose: true,
							message: '自动保存成功',
							type: 'success',
							customClass: 'backMessage',
							offset: 55,
						});
						this.getDraftVersionList();
					} else {
						this.$message({
							showClose: true,
							message: '保存失败 请稍后重试',
							type: 'success',
							customClass: 'backMessage',
							offset: 55,
						});
					}
				})
			},
			//预览
			PreviewDraggable() {
				let self = this;
				sessionStorage.setItem('draggableScaleLevel', JSON.stringify(this.scaleLevel))
				/*由于数据可能超出5M 使用离线仓库
				    不同于 localStorage,可以存储非字符串类型
				 * */
				this.$setItem('draggablePreview', this.draggable)
				//sessionStorage.setItem('draggablePreview', JSON.stringify(this.draggable))
				sessionStorage.setItem('indexMapEditor_user_code', JSON.stringify(this.$store.state.userData.code))
				sessionStorage.setItem('indexMapEditor_companyCode', JSON.stringify(this.$store.state.companyCode))
				// let routerMyCard = this.$router.resolve({
				// 	path: '/CompanyConsole/mapEditorPreview'
				// })
				// window.open( routerMyCard.href, 'mapEditorPreview'+self.companyId)
				this.windowOpen('/CompanyConsole/mapEditorPreview', 'mapEditorPreview' + self.companyId)
			},
			//应用
			UseSaveDraggable() {
				this.HiddenConnectPoint();
				this.stepClear();
				let objDraggable = JSON.parse(JSON.stringify(this.draggable.filter(item => item.ShowActive == true)))
				/*for(let obj of objDraggable){
					if(obj.ImgUrl){
						if(obj.ImgUrl.indexOf('http') != -1){
							obj.ImgUrl = new URL(obj.ImgUrl).pathname;
						}
					}
				}*/
				let content = {
					draggable: objDraggable,
					scaleLevel: this.scaleLevel,
          mapType:this.mapType,
          MapBgData:this.MapBgData
				}
				content = JSON.stringify(content)
				let formdata = new FormData();
				formdata.append('name', this.common.getTime()); //下面是要传递的参数
				formdata.append('type', 1);
				formdata.append('companyId', this.companyId);
				formdata.append('content', content);

				this.postForm('/DeviceMap/create', formdata).then((res) => {
					if(res.success == true) {
						localStorage.setItem('updataMark', 'true');
						this.$message({
							showClose: true,
							message: '应用成功',
							type: 'success',
							customClass: 'backMessage',
							offset: 55,
						});
						this.getVersionList();
					} else {
						this.$message({
							showClose: true,
							message: '应用失败 请稍后重试',
							type: 'success',
							customClass: 'backMessage',
							offset: 55,
						});
					}
				})
			},
			//复制
			CopyDraggable() {
				var arr = [];
				for(let dragg of this.draggable) {
					if(dragg.active) {
						arr.push(dragg);
					}
				}
				this.WaitCopyArr = arr;
				this.WaitCopyX = 1;
			},
			//粘贴
			PasteForDraggableThis() {
				this.revokeStorage(); /*存储撤销状态*/
				this.WaitCopyX++;
				this.CopyDelForDraggable([this.WaitCopyArr, this.WaitCopyX]);
			},
			EditionChoice(id) {
				let mark = false;
				if(this.step > 0) {
					this.$confirm('当前编辑的版本尚未保存，是否确定离开?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						//历史版本 隐藏列表(需求更改 可连续切换)
						//this.leftNavigationCurrent = 0;
						/*获取设备地图*/
						this.get('/DeviceMap/get', {
							id: id
						}).then((res) => {
							if(res.success == true) {
								let MapType;
								if(res.result.type == 1) {
									MapType = '历史版本'
								} else if(res.result.type == 2) {
									MapType = '草稿/自动保存'
								}
								this.MapUpdata({
									name: res.result.name,
									type: MapType
								})
								res.result.content = JSON.parse(res.result.content)
								this.scaleLevelModify(res.result.content.scaleLevel)
								this.draggableUpdata(res.result.content.draggable)
								this.stepClear();
							}
						})
					});
				} else {
					//历史版本 隐藏列表(需求更改 可连续切换)
					//this.leftNavigationCurrent = 0;
					/*获取设备地图*/
					this.get('/DeviceMap/get', {
						id: id
					}).then((res) => {
						if(res.success == true) {
							let MapType;
							if(res.result.type == 1) {
								MapType = '历史版本'
							} else if(res.result.type == 2) {
								MapType = '草稿/自动保存'
							}
							this.MapUpdata({
								name: res.result.name,
								type: MapType
							})
							res.result.content = JSON.parse(res.result.content)
							this.scaleLevelModify(res.result.content.scaleLevel)
							this.draggableUpdata(res.result.content.draggable)
							this.stepClear();
						}
					})
				}
			},
			draftChoice(id) {
				let mark = false;
				if(this.step > 0) {
					this.$confirm('当前编辑的版本尚未保存，是否确定离开?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						//草稿 隐藏列表(需求更改 可连续切换)
						//this.leftNavigationCurrent = 0;
						/*获取设备地图*/
						this.get('/DeviceMap/get', {
							id: id
						}).then((res) => {
							if(res.success == true) {
								let MapType;
								if(res.result.type == 1) {
									MapType = '历史版本'
								} else if(res.result.type == 2) {
									MapType = '草稿/自动保存'
								}
								this.MapUpdata({
									name: res.result.name,
									type: MapType
								})
								res.result.content = JSON.parse(res.result.content)
								this.scaleLevelModify(res.result.content.scaleLevel)
								this.draggableUpdata(res.result.content.draggable)
								this.stepClear();
							}
						})
					});
				} else {
					//草稿 隐藏列表(需求更改 可连续切换)
					//this.leftNavigationCurrent = 0;
					/*获取设备地图*/
					this.get('/DeviceMap/get', {
						id: id
					}).then((res) => {
						if(res.success == true) {
							let MapType;
							if(res.result.type == 1) {
								MapType = '历史版本'
							} else if(res.result.type == 2) {
								MapType = '草稿/自动保存'
							}
							this.MapUpdata({
								name: res.result.name,
								type: MapType
							})
							res.result.content = JSON.parse(res.result.content)
							this.scaleLevelModify(res.result.content.scaleLevel)
							this.draggableUpdata(res.result.content.draggable)
							this.stepClear();
						}
					})
				}
			},
			Layerclick(name) {
				this.revokeStorage(); /*存储撤销状态*/
				this.headerCurrent = 0;
				if(this.currentIndex != -1) {
					if(name == 'top') {
						//置顶
						this.zIndexTop();
					} else if(name == 'bottom') {
						//置底
						this.zIndexBottom();
					} else if(name == 'MoveUp') {
						//上移一层
						this.zIndexMoveUp();
					} else if(name == 'MoveDown') {
						//下移一层
						this.zIndexMoveDown();
					}
				}
			},
			Alignclick(id) {
				this.revokeStorage(); /*存储撤销状态*/
				this.headerCurrent = 0;
				if(id == 1) {
					//斜向对齐 x轴 2.5D
					this.ObliqueAlignmentX(this.currentIndex);
				} else if(id == 2) {
					//斜向对齐 y轴 2.5D
					this.ObliqueAlignmentY(this.currentIndex);
				} else if(id == 3) {
					//水平顶端对齐
					this.HorizontalAlignmentTop();
				} else if(id == 4) {
					//水平底端对齐
					this.HorizontalAlignmentBottom();
				} else if(id == 5) {
					//水平中心对齐
					this.HorizontalAlignmentCenter();
				} else if(id == 6) {
					//垂直左对齐
					this.VerticalAlignmentLeft();
				} else if(id == 7) {
					//垂直右对齐
					this.VerticalAlignmentRight();
				} else if(id == 8) {
					//垂直中心对齐
					this.VerticalAlignmentCenter();
				}
			},
			Meanclick(id) {
				this.revokeStorage(); /*存储撤销状态*/
				this.headerCurrent = 0;
				if(id == 9) {
					//x轴等距分布 2.5D
					this.HorizontalAlignmentMean();
					this.VerticalAlignmentMean();
					this.ObliqueAlignmentX(this.currentIndex);
				} else if(id == 10) {
					//y轴等距分布 2.5D
					this.HorizontalAlignmentMean();
					this.VerticalAlignmentMean();
					this.ObliqueAlignmentY(this.currentIndex);
				} else if(id == 11) {
					//水平等距分布
					this.HorizontalAlignmentMean();
				} else if(id == 12) {
					//垂直等距分布
					this.VerticalAlignmentMean();
				}
			},
			leftNavigationClick(name) {
				if(this.$refs[name].className.indexOf('active') == -1) {
					if(name == 'Edition') {
						this.leftNavigationCurrent = 1;
					} else if(name == 'draft') {
						this.leftNavigationCurrent = 2;
					} else if(name == 'control') {
						this.leftNavigationCurrent = 0;
					}
				} else {
					this.leftNavigationCurrent = 0;
				}
			},
			headerClick(name) {
				if(this.$refs[name].className.indexOf('active') == -1) {
					if(name == 'Layer') {
						this.headerCurrent = 1;
					} else if(name == 'Align') {
						this.headerCurrent = 2;
					} else if(name == 'Mean') {
						this.headerCurrent = 3;
					}
				} else {
					this.headerCurrent = 0;
				}
			},
			mousedown(event) {
				var targ
				if(!e) var e = window.event
				if(e.target) targ = e.target
				else if(e.srcElement) targ = e.srcElement
				if(targ.nodeType == 3) // defeat Safari bug
					targ = targ.parentNode
				if(targ.getAttribute('data-name') != null) {
					if(targ.getAttribute('data-name') == '基本控件') {
						this.NameId = parseInt(targ.getAttribute('data-name-id'));
						this.ContentId = targ.getAttribute('data-content-id');
						for(var a = 0; a < this.defaultBasicConfig.length; a++) {
							if(this.defaultBasicConfig[a].id == this.NameId) {
                console.log(this.defaultBasicConfig,this.$store)
								for(var i = 0; i < this.defaultBasicConfig[a].content.length; i++) {
									if(this.defaultBasicConfig[a].content[i].id == this.ContentId) {
										this.width = this.defaultBasicConfig[a].content[i].width;
										this.height = this.defaultBasicConfig[a].content[i].height;
										/*
										宽和高除以2是为了 实现鼠标位于生成的组件的中心，325与45是当前画布位于页面的x，y
										1373为画布的尺寸
										*/
										let x, y;
										if(this.scaleLevel == 1) {
											x = (event.clientX - 325 - (this.width / 2)) - this.editorLeft;
											y = (event.clientY - 99 - (this.height / 2)) - this.editorTop;
										} else if(this.scaleLevel == 0.625) {
											x = ((event.clientX - 325) / 0.625 - 400 - (this.width / 2)) - this.editorLeft;
											y = ((event.clientY - 99) / 0.625 - 252 - (this.height / 2)) - this.editorTop;
										} else if(this.scaleLevel == 0.5) {
											x = ((event.clientX - 325) / 0.5 - 674 - (this.width / 2)) - this.editorLeft;
											y = ((event.clientY - 99) / 0.5 - 422 - (this.height / 2)) - this.editorTop;
										} else if(this.scaleLevel == 0.3125) {
											x = ((event.clientX - 325) / 0.3125 - 1495 - (this.width / 2)) - this.editorLeft;
											y = ((event.clientY - 99) / 0.3125 - 925 - (this.height / 2)) - this.editorTop;
										} else if(this.scaleLevel == 0.25) {
											x = ((event.clientX - 325) / 0.25 - 2040 - (this.width / 2)) - this.editorLeft;
											y = ((event.clientY - 99) / 0.25 - 1265 - (this.height / 2)) - this.editorTop;
										}
										let Object = {
											NameId: this.NameId,
											ContentId: this.ContentId,
											centerPointX: x,
											centerPointY: y,
											x: x,
											y: y
										}
										this.revokeStorage(); /*存储撤销状态*/
										this.mouseMark = true
										this.ActiveForDraggableAllFalse();
										this.draggableBasicAdd(Object);
										//显示当前首选设备 连接点;切换当前首选状态
										this.NowActiveModifyTrue(this.currentIndex);
										this.$refs.Equipment.$el.style.zIndex = 1;

									}
								}
							}

						}

					} else {
						this.NameId = parseInt(targ.getAttribute('data-name-id'));
						this.ContentId = targ.getAttribute('data-content-id');
						for(var a = 0; a < this.defaultDeviceConfig.length; a++) {
							if(this.defaultDeviceConfig[a].id == this.NameId) {
								for(var i = 0; i < this.defaultDeviceConfig[a].content.length; i++) {
									if(this.defaultDeviceConfig[a].content[i].id == this.ContentId) {
										this.width = this.defaultDeviceConfig[a].content[i].width;
										this.height = this.defaultDeviceConfig[a].content[i].height;
										/*
										宽和高除以2是为了 实现鼠标位于生成的组件的中心，325与45是当前画布位于页面的x，y
										*/
										let x, y;
										if(this.scaleLevel == 1) {
											x = (event.clientX - 325 - (this.width / 2)) - this.editorLeft;
											y = (event.clientY - 99 - (this.height / 2)) - this.editorTop;
										} else if(this.scaleLevel == 0.625) {
											x = ((event.clientX - 325) / 0.625 - 400 - (this.width / 2)) - this.editorLeft;
											y = ((event.clientY - 99) / 0.625 - 252 - (this.height / 2)) - this.editorTop;
										} else if(this.scaleLevel == 0.5) {
											x = ((event.clientX - 325) / 0.5 - 674 - (this.width / 2)) - this.editorLeft;
											y = ((event.clientY - 99) / 0.5 - 422 - (this.height / 2)) - this.editorTop;
										} else if(this.scaleLevel == 0.3125) {
											x = ((event.clientX - 325) / 0.3125 - 1500 - (this.width / 2)) - this.editorLeft;
											y = ((event.clientY - 99) / 0.3125 - 934 - (this.height / 2)) - this.editorTop;
										} else if(this.scaleLevel == 0.25) {
											x = ((event.clientX - 325) / 0.25 - 2048 - (this.width / 2)) - this.editorLeft;
											y = ((event.clientY - 99) / 0.25 - 1272 - (this.height / 2)) - this.editorTop;
										}
										let Object = {
											NameId: this.NameId,
											ContentId: this.ContentId,
											centerPointX: x,
											centerPointY: y,
											x: x,
											y: y
										}
										this.revokeStorage(); /*存储撤销状态*/
										this.mouseMark = true
										this.ActiveForDraggableAllFalse();
										this.draggableDeviceAdd(Object);
										//显示当前首选设备 连接点;切换当前首选状态
										this.NowActiveModifyTrue(this.currentIndex);
										this.$refs.Equipment.$el.style.zIndex = 1;
									}
								}
							}

						}

					}

				}
				if(targ.getAttribute('leftNavigation-id') == null) {
					this.leftNavigationCurrent = 0;
				}
				if(targ.getAttribute('header-id') == null) {
					this.headerCurrent = 0;
				}
				if(targ.getAttribute('Near-id') == null) {
					this.NearClose();
				}
				if(targ.getAttribute('Far-id') == null) {
					this.FarClose();
				}
			},
			mouseup(event) {
				if(this.mouseMark) {

					var ThisActive = this.draggable.filter(item => item.index == this.index - 1)[0];
					if(this.scaleLevel == 1) {
						if(ThisActive.x < -45 - this.editorLeft || ThisActive.y < -99 - this.editorTop) {
							this.ShowActiveUpdata(ThisActive.index);
						}
					} else if(this.scaleLevel == 0.625) {
						if(ThisActive.x < -482 - this.editorLeft || ThisActive.y < -322 - this.editorTop) {
							this.ShowActiveUpdata(ThisActive.index);
						}
					} else if(this.scaleLevel == 0.5) {
						if(ThisActive.x < -772 - this.editorLeft || ThisActive.y < -506 - this.editorTop) {
							this.ShowActiveUpdata(ThisActive.index);
						}
					} else if(this.scaleLevel == 0.3125) {
						if(ThisActive.x < -1649 - this.editorLeft || ThisActive.y < -1063 - this.editorTop) {
							this.ShowActiveUpdata(ThisActive.index);
						}
					} else if(this.scaleLevel == 0.25) {
						if(ThisActive.x < -2233 - this.editorLeft || ThisActive.y < -1435 - this.editorTop) {
							this.ShowActiveUpdata(ThisActive.index);
						}
					}
					//自动附着连接点
					this.AutoAttachConnectPoint(this.currentIndex); //将当前聚焦index与相应的x，y轴放入obj
					//自动附着斜对齐线
					this.AutoAttachSkewAlignment(this.currentIndex); //将当前聚焦index与相应的x，y轴放入obj
					//自动附着设备斜对齐线
					this.AutoAttachEquiSkewAlignment(this.currentIndex); //将当前聚焦index与相应的x，y轴放入obj

					//隐藏斜对齐线
					this.SkewAlignmentClose(this.currentIndex)
					//隐藏设备斜对齐线
					this.SkewAlignmentEquipmentClose(this.currentIndex)
					this.$refs.Equipment.$el.style.zIndex = 11;
					this.mouseMark = false;
				}
			},
			mousemove(event) {
				if(this.mouseMark) {
					let x, y;
					if(this.draggable[this.draggable.length - 1].typeDefault == '基础控件') {
						if(this.scaleLevel == 1) {
							x = (event.clientX - 325 - (this.width / 2)) - this.editorLeft;
							y = (event.clientY - 99 - (this.height / 2)) - this.editorTop;
						} else if(this.scaleLevel == 0.625) {
							x = ((event.clientX - 325) / 0.625 - 400 - (this.width / 2)) - this.editorLeft;
							y = ((event.clientY - 99) / 0.625 - 252 - (this.height / 2)) - this.editorTop;
						} else if(this.scaleLevel == 0.5) {
							x = ((event.clientX - 325) / 0.5 - 674 - (this.width / 2)) - this.editorLeft;
							y = ((event.clientY - 99) / 0.5 - 422 - (this.height / 2)) - this.editorTop;
						} else if(this.scaleLevel == 0.3125) {
							x = ((event.clientX - 325) / 0.3125 - 1495 - (this.width / 2)) - this.editorLeft;
							y = ((event.clientY - 99) / 0.3125 - 925 - (this.height / 2)) - this.editorTop;
						} else if(this.scaleLevel == 0.25) {
							x = ((event.clientX - 325) / 0.25 - 2040 - (this.width / 2)) - this.editorLeft;
							y = ((event.clientY - 99) / 0.25 - 1265 - (this.height / 2)) - this.editorTop;
						}
					} else if(this.draggable[this.draggable.length - 1].typeDefault == '企业控件') {
						if(this.scaleLevel == 1) {
							x = (event.clientX - 325 - (this.width / 2)) - this.editorLeft;
							y = (event.clientY - 99 - (this.height / 2)) - this.editorTop;
						} else if(this.scaleLevel == 0.625) {
							x = ((event.clientX - 325) / 0.625 - 400 - (this.width / 2)) - this.editorLeft;
							y = ((event.clientY - 99) / 0.625 - 252 - (this.height / 2)) - this.editorTop;
						} else if(this.scaleLevel == 0.5) {
							x = ((event.clientX - 325) / 0.5 - 674 - (this.width / 2)) - this.editorLeft;
							y = ((event.clientY - 99) / 0.5 - 422 - (this.height / 2)) - this.editorTop;
						} else if(this.scaleLevel == 0.3125) {
							x = ((event.clientX - 325) / 0.3125 - 1500 - (this.width / 2)) - this.editorLeft;
							y = ((event.clientY - 99) / 0.3125 - 934 - (this.height / 2)) - this.editorTop;
						} else if(this.scaleLevel == 0.25) {
							x = ((event.clientX - 325) / 0.25 - 2048 - (this.width / 2)) - this.editorLeft;
							y = ((event.clientY - 99) / 0.25 - 1272 - (this.height / 2)) - this.editorTop;
						}
					}
					let Change = 'positionCount';
					this.CurrentPosition({
						index: this.draggable.length,
						x: x,
						y: y,
						centerPointX: x,
						centerPointY: y,
						Change: Change,
					}); //修改画布里当前聚焦元素的x，y

					//显示斜对齐线
					this.SkewAlignmentShow(this.currentIndex)
					//显示设备斜对齐线
					this.SkewAlignmentEquipmentShow(this.currentIndex)
				}
			}
		},
		watch: {
			scaleLevel(val) {
				this.ValueNum = val * 100;
			},
			ValueNum(val) {
				this.scaleLevelModify(val / 100)
			},
		},
		beforeDestroy() {
			this.$parent.ChangeHeaderShow();
			if(this.autoSaveInterval) {
				clearInterval(this.autoSaveInterval); // 在Vue实例销毁前，清除我们的定时器
			}
		},
	}
</script>
<style>
	.ctrl {
		line-height: 54px;
		font-size: 17px !important;
		letter-spacing: 1px;
		cursor: unset !important;
	}

	.backMessage {
		background-color: #363738 !important;
		border: 0px !important;
	}

	.backMessage .el-message__content {
		color: #DADADA !important;
	}

	.backMessage .el-message__icon.el-icon-success {
		color: #DADADA !important;
	}

	.el-selectDiy {
		background: rgb(37, 38, 38) !important;
		border: 1px solid rgba(112, 112, 112, 0.5) !important;
		border-radius: 1px !important;
	}

	.el-selectDiy .el-select-dropdown__item.selected {
		color: #DADADA;
		font-weight: unset;
	}

	.el-selectDiy .el-select-dropdown__item.hover,
	.el-selectDiy .el-select-dropdown__item:hover {
		background: #151515 !important;
	}

	.el-selectDiy .el-select-dropdown__list {
		padding: 0px !important;
	}

	.el-selectDiy .popper__arrow {
		border-bottom-color: rgba(112, 112, 112, 0.5) !important;
	}

	.el-selectDiy .popper__arrow::after {
		border-bottom-color: rgba(112, 112, 112, 0.5) !important;
	}

	.el-selectDiy .el-select-dropdown__empty {
		font-size: 12px;
	}

	.el-popperDiy .el-cascader-panel .el-checkbox__inner {
		background-color: #DADADA !important;
		border-radius: 1px;
		width: 12px;
		height: 12px;
		border-color: #DADADA !important;
	}

	.el-popperDiy .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
		background-color: #151515 !important;
	}

	.el-popperDiy .el-cascader-menu__hover-zone {
		display: none;
	}

	.el-popperDiy .el-checkbox__inner:after {
		border: 1px solid #000;
		height: 7px;
		left: 3px;
		width: 2px;
		border-left: 0;
		border-top: 0;
	}

	.el-popperDiy .el-cascader-node.in-active-path,
	.el-popperDiy .el-cascader-node.is-active,
	.el-popperDiy .el-cascader-node.is-selectable.in-checked-path {
		color: #DADADA;
		font-weight: unset;
	}

	.el-popperDiy {
		border: 1px solid rgba(112, 112, 112, 0.5) !important;
		border-radius: 1px !important;
		background: rgb(37, 38, 38) !important;
		/*transition: .1s !important;*/
	}

	.el-popperDiy .popper__arrow {
		border-bottom-color: rgba(112, 112, 112, 0.5) !important;
	}

	.el-popperDiy .popper__arrow:after {
		border-bottom-color: rgba(112, 112, 112, 0.5) !important;
	}

	.el-popperDiy .el-cascader-node {
		transition: .1s;
	}

	.el-popperDiy .el-cascader-menu {
		border-right: 1px solid rgba(112, 112, 112, 0.5);
	}

	.el-popperDiy .el-cascader-node:not(.is-disabled):focus,
	.el-popperDiy .el-cascader-node:not(.is-disabled):hover {
		background: #151515 !important;
	}

	.Mean_list_box_ab {
		position: absolute;
		height: auto;
		width: 100%;
	}

	.Mean_list .Mean_list_box_ab .Mean_list_box {
		font-size: 12px;
		line-height: 36px;
		width: 100%;
		height: 36px;
		float: left;
		cursor: pointer;
		color: #E6E6E6;
		text-align: left;
		letter-spacing: .5px;
	}

	.Mean_list .Mean_list_box_ab .Mean_list_box .name {
		position: relative;
		left: 22px;
	}

	.Mean_list .Mean_list_box_ab .Mean_list_box .nameQuick {
		position: absolute;
		/*left: 100px;*/
		right: 15px;
		opacity: .7;
	}

	.Mean_list .Mean_list_box_ab .Mean_list_box.SkewAlineAlignment {
		background: url(../../../assets/image/editor/icon/SkewAlineAlignment.png)no-repeat;
		background-position: left center;
		background-position-x: 20px;
	}

	.Mean_list .Mean_list_box_ab .Mean_list_box:hover {
		background-color: #2571EF;
	}

	.Align_list_box_ab {
		position: absolute;
		height: auto;
		width: 100%;
	}

	.Align_list .Align_list_box_ab .Align_list_box {
		font-size: 12px;
		line-height: 36px;
		width: 100%;
		height: 36px;
		float: left;
		cursor: pointer;
		color: #E6E6E6;
		text-align: left;
		letter-spacing: .5px;
	}

	.Align_list .Align_list_box_ab .Align_list_box .name {
		position: relative;
		left: 22px;
	}

	.Align_list .Align_list_box_ab .Align_list_box .nameQuick {
		position: absolute;
		/*left: 100px;*/
		right: 15px;
		opacity: .7;
	}

	.Align_list .Align_list_box_ab .Align_list_box.SkewAlineAlignment {
		background: url(../../../assets/image/editor/icon/SkewAlineAlignment.png)no-repeat;
		background-position: left center;
		background-position-x: 20px;
	}

	.Align_list .Align_list_box_ab .Align_list_box:hover {
		background-color: #2571EF;
	}

	.Layer_list_box_ab {
		position: absolute;
		height: auto;
		width: 198px;
	}

	.Layer_list .Layer_list_box_ab .Layer_list_box {
		font-size: 12px;
		line-height: 36px;
		width: 100%;
		height: 36px;
		float: left;
		cursor: pointer;
		color: #E6E6E6;
		/*text-align: left;*/
		letter-spacing: .5px;
	}

	.Layer_list .Layer_list_box_ab .Layer_list_box .name {
		position: absolute;
		left: 43px;
	}

	.Layer_list .Layer_list_box_ab .Layer_list_box .nameQuick {
		position: relative;
		left: 50px;
		opacity: .7;
	}

	.Layer_list .Layer_list_box_ab .Layer_list_box.top {
		background: url(../../../assets/image/editor/icon/topGo.png)no-repeat;
		background-position: left center;
		background-position-x: 20px;
	}

	.Layer_list .Layer_list_box_ab .Layer_list_box.bottom {
		background: url(../../../assets/image/editor/icon/bottomGo.png)no-repeat;
		background-position: left center;
		background-position-x: 20px;
	}

	.Layer_list .Layer_list_box_ab .Layer_list_box.MoveUp {
		background: url(../../../assets/image/editor/icon/MoveUp.png)no-repeat;
		background-position: left center;
		background-position-x: 20px;
	}

	.Layer_list .Layer_list_box_ab .Layer_list_box.MoveDown {
		background: url(../../../assets/image/editor/icon/MoveDown.png)no-repeat;
		background-position: left center;
		background-position-x: 20px;
	}

	.Layer_list .Layer_list_box_ab .Layer_list_box:hover {
		background-color: #2571EF;
	}

	.Edition_list_box_ab {
		position: absolute;
		width: 225px;
		height: auto;
	}

	.Edition_list .Edition_list_box_ab .Edition_list_box {
		border-bottom: 1px solid #151515;
		font-size: 14px;
		line-height: 51px;
		width: 100%;
		height: 51px;
		text-indent: 11px;
		color: #DADADA;
		float: left;
		text-align: left;
		cursor: pointer;
		transition: .1s;
	}

	.Edition_list .Edition_list_box_ab .Edition_list_box:hover {
		background-color: #363738;
	}

	.draft_list_box_ab {
		position: absolute;
		width: 225px;
		height: auto;
	}

	.draft_list .draft_list_box_ab .draft_list_box {
		border-bottom: 1px solid #151515;
		font-size: 14px;
		line-height: 51px;
		width: 100%;
		height: 51px;
		text-indent: 11px;
		color: #DADADA;
		float: left;
		text-align: left;
		cursor: pointer;
		transition: .1s;
	}

	.draft_list .draft_list_box_ab .draft_list_box:hover {
		background-color: #363738;
	}

	.Layer_list {
		left: 288px;
		width: 198px !important;
	}

	.Align_list {
		left: 368px;
		width: 195px !important;
	}

	.Mean_list {
		left: 433px;
		width: 195px !important;
	}

	.header-function .header_list {
		/*width: 180px;*/
		height: 0;
		position: absolute;
		background-color: rgba(54, 55, 56, 1);
		/*left: 149px;*/
		z-index: 20;
		-webkit-transition: .1s;
		transition: .1s;
		overflow: hidden;
		top: 55px;
	}

	.index_editor .header-function .active.Layer_list {
		height: 143px;
	}

	.index_editor .header-function .active.Align_list {
		height: 288px;
	}

	.header_function_input span {
		position: absolute;
		/* left: 0; */
		right: 33px;
		top: 18px;
		font-size: 13px;
		width: 12px;
		height: 18px;
	}

	.header_function_input>>>.el-input-number .el-input-number__increase.is-disabled {
		border: 0px !important;
		background: transparent !important;
		color: #606266 !important;
		margin-right: -10px;
	}

	.header_function_input>>>.el-input-number .el-input-number__increase {
		border: 0px !important;
		background: transparent !important;
		color: #fff !important;
		margin-right: -10px;
	}

	.header_function_input>>>.el-input-number .el-input-number__decrease.is-disabled {
		border: 0px !important;
		background: transparent !important;
		color: #606266 !important;
		margin-left: -10px;
	}

	.header_function_input>>>.el-input-number .el-input-number__decrease {
		border: 0px !important;
		background: transparent !important;
		color: #fff !important;
		margin-left: -10px;
	}

	.header_function_input>>>.el-input .el-input__inner {
		background-color: #151515 !important;
		border: 0px !important;
		width: 60px;
		height: 20px;
		padding: 0;
		border-radius: 2px;
		color: #A8A8A8;
		text-indent: -10px;
	}

	.header_function_input .el-input-number {
		width: 115px
	}

	.header-function {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		height: 54px;
		/*width: 615px;*/
		width: max-content;
	}

	.header-last {
		left: unset !important;
		width: 210px !important;
	}

	.header-function .header_function {
		width: 70px;
		height: 54px;
		float: left;
		text-align: center;
		color: #848484;
		font-size: 10px;
		cursor: no-drop;
		position: relative;
		transition: .2s;
	}

	.header-function .header_function_input {
		width: 115px;
		height: 34px;
		float: left;
		text-align: center;
		color: #A8A8A8;
		font-size: 10px;
		padding-top: 20px;
		position: relative;
	}

	.header_function.active {
		background-color: #242424;
		color: #DDDDDD;
		cursor: pointer;
	}

	.header-function .header_function.hover:hover {
		background-color: #242424;
	}

	.header-function .header_function.hover.Revoke {
		color: #DDDDDD;
		cursor: pointer;
	}

	.header-function .header_function.hover.Layer {
		color: #DDDDDD;
		cursor: pointer;
	}

	.header-function .header_function.hover.Align {
		color: #DDDDDD;
		cursor: pointer;
	}

	.header-function .header_function.hover.Mean {
		color: #DDDDDD;
		cursor: pointer;
	}

	.header-function .header_function.hover.Copy {
		color: #DDDDDD;
		cursor: pointer;
	}

	.header-function .header_function.hover.paste {
		color: #DDDDDD;
		cursor: pointer;
	}

	.header-function .header_function img {
		margin-top: 10px;
	}

	.header-function .header_function p {
		-webkit-transform: scale(0.95);
	}

	.index_editor .leftNavigation .active.Edition_list {
		width: 225px;
	}

	.index_editor .leftNavigation .active.draft_list {
		width: 225px;
	}

	.leftNavigation .leftNavigation_list {
		width: 0;
		height: calc(100vh - 53px);
		position: absolute;
		background-color: #252626;
		left: 50px;
		z-index: 20;
		/* transition: .3s; */
		top: 1px;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.leftNavigation .leftNavigation_list::-webkit-scrollbar {
		width: 10px;
	}

	.leftNavigation .leftNavigation_list::-webkit-scrollbar-button:start {
		background: url(../../../assets/image/editor/icon/top.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.leftNavigation .leftNavigation_list::-webkit-scrollbar-button:end {
		background: url(../../../assets/image/editor/icon/bottom.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.leftNavigation .leftNavigation_list::-webkit-scrollbar-track {
		background: rgba(32, 33, 34, 1);
		width: 11px;
	}

	.leftNavigation .leftNavigation_list::-webkit-scrollbar-thumb {
		cursor: pointer;
		background: rgba(119, 120, 120, 1);
		width: 11px;
	}

	.leftNavigation {
		height: calc(100% - 54px);
		width: 49px;
		background: rgba(54, 55, 56, 1);
		float: left;
		position: relative;
		border-top: 1px solid #252626;
	}

	.leftNavigation .leftNavigation_box {
		float: left;
		width: 49px;
		height: 59px;
		cursor: pointer;
		text-align: center;
		transition: .1s;
		position: relative;
	}

	.leftNavigation .leftNavigation_box.control {
		background: url(../../../assets/image/editor/icon/control.png)no-repeat center;
	}

	.leftNavigation .leftNavigation_box.Edition {
		background: url(../../../assets/image/editor/icon/Edition.png)no-repeat center;
	}

	.leftNavigation .leftNavigation_box.draft {
		background: url(../../../assets/image/editor/icon/draft.png)no-repeat center;
	}

	.leftNavigation .leftNavigation_box.Preservation {
		background: url(../../../assets/image/editor/icon/Preservation.png)no-repeat center;
	}

	.leftNavigation .leftNavigation_box.preview {
		background: url(../../../assets/image/editor/icon/preview.png)no-repeat center;
	}

	.leftNavigation .leftNavigation_box.application {
		background: url(../../../assets/image/editor/icon/application.png)no-repeat center;
	}

	.leftNavigation .leftNavigation_box:hover {
		background-color: #242424;
	}

	.leftNavigation .leftNavigation_box.active {
		background-color: #242424;
	}

	* {
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-khtml-user-select: none;
		/*早期浏览器*/
		-moz-user-select: none;
		/*火狐*/
		-ms-user-select: none;
		/*IE10*/
		user-select: none;
	}

	input {
		-webkit-user-select: auto;
		/*webkit浏览器*/
	}

	.CanvasInt {
		z-index: 10;
	}

	.Equipment,
	.header_body {
		z-index: 11;
	}

	.leftNavigation {
		z-index: 12;
	}

	.Attribute {
		z-index: 50;
	}

	textarea {
		-webkit-user-select: auto;
		/*webkit浏览器*/
	}

	.clearfix:after {
		content: "";
		display: block;
		clear: both;
	}

	.index_editor {
		width: 100%;
		/* height: 937px; */
		position: absolute;
		overflow: hidden;
		top: 0;
		bottom: 0;
		min-height: 937px;
	}

	.floatLeft_editor {
		float: left;
	}
	/*编辑器边框*/

	.index_editor .header_body {
		width: 100%;
		position: relative;
		float: left;
		height: 54px;
		background-color: #353738;
	}

	.index_editor .header_body .header-title {
		float: left;
		margin-left: 10px;
		height: 54px;
	}

	.index_editor .header_body .header_title {
		height: 100%;
		float: left;
		line-height: 54px;
		margin-left: 10px;
		color: #DADADA;
		font-size: 13px;
	}

	.yoyoo-ddr .resize-handler {
		z-index: 99;
	}
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/index/indexMapEditor.vue